(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('TermsAndConditionsPatchDto', [TermsAndConditionsPatchDtoFn]);

    /* main user data transfer object for interacting with user objects */
    function TermsAndConditionsPatchDtoFn() {
        return function (agendaId, accepted) {
            // main attributes
            this.agendaId = agendaId;
            this.accepted = accepted;
        };
    }
})();